module.exports = __webpack_public_path__ + "assets/1c-bitrix.5a34654a.svg";